export const authorizedCardHeaderDetails = {
    /** Display authorized credit card header with details */
    displayAuthorizeCreditCardHeaderDetails: false,
};
